import { NavItem } from 'common/HorizontalNavPage';
import { SettingsServiceTypes } from 'common/settingsService/types';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { FeaturesNames } from 'src/definitions/custom-models';
import { LaunchDarklyFeatureFlagKeys } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';

export enum ENGAGEMENTS_TAB {
  JOB_CATALOGUES = 'job-catalogues',
  RATE_CARDS = 'rate-cards',
  GENERAL = 'general',
  TERMINATION_REASONS = 'termination-reasons',
  GENDER = 'gender'
}

interface LaunchDarklyFlag {
  source: 'LaunchDarkly';
  value: LaunchDarklyFeatureFlagKeys;
}

interface SettingsServiceFlag {
  source: 'SettingsService';
  group: SettingsServiceTypes.GroupNames;
  value: SettingsServiceTypes.GroupItemKeysFor<SettingsServiceTypes.GroupNames>;
}

interface TenantYmlFlag {
  source: 'TenantYml';
  value: FeaturesNames;
}

export type SupportedFlags = LaunchDarklyFlag | SettingsServiceFlag | TenantYmlFlag;

export interface EngagementNavItem extends NavItem {
  pathSchema?: string;
  component?:
    | React.ComponentType<React.PropsWithChildren<RouteComponentProps<any>>>
    | React.ComponentType<React.PropsWithChildren<any>>;
  flag?: SupportedFlags;
}

export const defaultPath = ENGAGEMENTS_TAB.JOB_CATALOGUES;

export const PATH_SCHEMA = '/settings/engagements';
